



































import { Component, Vue } from 'vue-property-decorator';

import FilterItem from '@/components/dashboard/FilterItem.vue';

@Component({ components: { FilterItem } })
export default class OrganisationFilters extends Vue {
  typeItems = [
    { label: this.$t('organisations.orgTypes.regular'), value: '0' },
    { label: this.$t('organisations.orgTypes.trainingProvider'), value: '1' },
    { label: this.$t('organisations.orgTypes.trainingSession'), value: '2' },
  ];

  accessItems = [
    { label: this.$t('organisations.access.labels.active'), value: 'true' },
    { label: this.$t('organisations.access.labels.inactive'), value: 'false' },
  ];

  manualAccessItems = [
    {
      label: this.$t('organisations.access.options.manualTrue'),
      value: 'true',
    },
    {
      label: this.$t('organisations.access.options.manualFalse'),
      value: 'false',
    },
  ];

  trainingItems = [
    { label: this.$t('organisations.status.activeTraining'), value: 'true' },
    { label: this.$t('organisations.status.inactiveTraining'), value: 'false' },
  ];
}
